import { render, staticRenderFns } from "./ConsulenzaTelematicaEdit.vue?vue&type=template&id=d55cddf4&scoped=true"
import script from "./ConsulenzaTelematicaEdit.vue?vue&type=script&lang=js"
export * from "./ConsulenzaTelematicaEdit.vue?vue&type=script&lang=js"
import style0 from "./ConsulenzaTelematicaEdit.vue?vue&type=style&index=0&id=d55cddf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55cddf4",
  null
  
)

export default component.exports